import {useQuery} from 'react-query';
import getStoreCommentsAndRateCounts from '.';

const useGetStoreCommentsAndRateCounts = () => {
  const {data, isLoading} = useQuery(
    ['get-store-comments-rate'],
    () => getStoreCommentsAndRateCounts(),
    {
      // Optional: Set stale time to prevent refetching
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Optional: Cache time
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );

  return {data, isLoading};
};

export default useGetStoreCommentsAndRateCounts;
